// This is in a separate file to avoid circular dependencies. Play carefully if you move these :)
import type { ActionTemplateResource, ChannelResource, WorkerPoolResource, VariableSetResource, TriggerResource, UserOnboardingResource, EnvironmentV2Resource, GetTeamsLookupBffResponseTeam, ProjectSummaryResource, } from "@octopusdeploy/octopus-server-client";
import type { LoadedLibraryVariableSets } from "~/areas/projects/components/Variables/AllVariables/SharedAllVariablesPage";
import type { TagIndex } from "~/components/tenantTagsets";
import type { EnvironmentOption, RunOn } from "./types";
export type FailedPermissionCheck = {
    type: "No Permission";
};
export const NoPermission: FailedPermissionCheck = { type: "No Permission" };
export function isFailedPermissionCheck<T extends {}>(value: T | FailedPermissionCheck | undefined | null): value is FailedPermissionCheck {
    if (value === undefined || value === null) {
        return false;
    }
    return "type" in value && value.type === "No Permission";
}
export interface ProcessStepLookupState {
    environments: EnvironmentV2Resource[];
    machineRoles: string[];
    availableWorkerPools: WorkerPoolResource[];
    tagIndex: TagIndex;
    actionTemplate: ActionTemplateResource | null | FailedPermissionCheck;
    channels: ChannelResource[];
    processVariableSet: VariableSetResource | FailedPermissionCheck;
    libraryVariableSets: LoadedLibraryVariableSets[] | FailedPermissionCheck;
    projectTriggers: TriggerResource[];
    userOnboarding: UserOnboardingResource | null;
    teams: GetTeamsLookupBffResponseTeam[];
    projects: ProjectSummaryResource[];
}
export interface ProcessStepActionState {
    pageTitle: string;
    isBuiltInWorkerEnabled: boolean;
    actionTypeName: string;
    runOn: RunOn | null;
    environmentOption: EnvironmentOption;
}
